

import Cookies from 'js-cookie';
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import './style.css'
import Layout from '../../components/Layout/AdminLayout/AdminLayout';
import AdminRegistryTable from '../../components/Table/AdminRegistryTable/AdminRegistryTable';
import adminRegistryService from './adminRegistryService';
import helpers from '../../helpers/index';

import { AdminRegistryTableData } from '../../interface/IAdminRegistry';
import { Response } from '../../interface/IResponse';

import SuccessModal from '../../components/Modal/SuccessModal';
import ConfirmModal from '../../components/Modal/ConfirmModal';

import searchIcon from '../../assets/search-interface-symbol.png';
import confirmIcon from '../../assets/warning-icon.png';



function AdminRegistry() {

  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [usernameState, setUsername] = useState("");
  const [isReadOnly, setIsReadOnly] = useState(false);


  var dispatch = useDispatch();
  const navigate = useNavigate();


  const [adminRegistryTableData, setAdminRegistryTableData] = useState<AdminRegistryTableData[]>([]);

  function getPermission() {

    var permission = helpers.getPermission();
    setIsReadOnly(permission == "ReadOnly");
  }

  const adminRegistryList = async () => {
    try {

      var response = await adminRegistryService.getAdminRegistryList();

      if (response.status >= 200 && response.status < 300) {
        const responseData = response.data.result;

        const updatedData = responseData.map((item: AdminRegistryTableData) => ({
          ...item,
          firstName: item.firstname,
          userId: item.userId,
          username: item.username,
          email: item.email,
          createdDateTime: item.createdDateTime

        }));
        setAdminRegistryTableData(updatedData);

      }
      else {

        throw new Error(response.data.message);
      }
    }
    catch (error) {
      console.log('adminRegistryList error:: ', error);
    }

  }

  async function DeleteAdminButtonClick(username: string) {
    try {


      setUsername(username);


      openConfirmModal();


    }
    catch (error) {
      console.log('DeleteAdminButtonClick:: ', error);

    }

  }

  async function ConfirmAdminDeleteButtonClick() {
    try {

      setConfirmModalOpen(false);
      document.querySelector('.loader-container')?.classList.add('loader');

      await adminRegistryService.deleteAdmin(usernameState);

      setResponseMessage(usernameState + "\nDeleted Successfully ");
      openModal();
      await adminRegistryList();
    }
    catch (error) {
      console.log('ConfirmAdminDeleteButtonClick:: ', error);
    }
    finally {
      document.querySelector('.loader-container')?.classList.remove('loader');
    }
  }

  function AddAdministratorButtonClick() {

    navigate('/Admin/CreateAdmin');

  }

  function openModal() {
    setModalOpen(true);
  };

  function onClose() {
    setModalOpen(false);
  };


  function openConfirmModal() {

    if (usernameState) {
      setResponseMessage('Are you sure you want to \ndelete ' + usernameState);
      setConfirmModalOpen(true);
    }
  }

  function onCloseConfirmModal() {
    setConfirmModalOpen(false);
    setModalOpen(false);
    setUsername("");
  }

  useEffect(() => {
    (async () => {
      document.querySelector('.loader-container')?.classList.add('loader');

      openConfirmModal();
      await adminRegistryList();

      getPermission();
      document.querySelector('.loader-container')?.classList.remove('loader');
    })();
  }, [usernameState]);

  return (
    <Layout>
      <div>
        <ConfirmModal icon={confirmIcon} message={responseMessage} buttonYesText="Delete" isOpen={isConfirmModalOpen} onYes={ConfirmAdminDeleteButtonClick} onNo={onCloseConfirmModal} />
        <SuccessModal message={responseMessage} isOpen={isModalOpen} onClose={onClose} />
      </div>
      <div className="title-container">
        <div className="dv-title">

          <h1>Admin Panel</h1>

        </div>
        <div className="title-btn-container vertical-flex-bottom">

          <button type="button" id="btnAddAdmin"
            onClick={AddAdministratorButtonClick}
            className="btn-green-1 center-middle"
            disabled={isReadOnly}>+ Admin Registration</button>

        </div>
      </div>
      <br />
      <div className="content-container">
        <div className="table-container">
          <div className="width-100 right-align">
            <div className='container-fit'>
              {/* <div className="icon-container">
                <span className="icon-login"><img src={searchIcon} className="responsive-image" /></span>
                <input type="text" className="textbox-green-1" name="Search" id="txtSearch" placeholder="Search"
                            />
              </div> */}
            </div>
          </div>
          <div>
            <AdminRegistryTable data={adminRegistryTableData} deleteAdminButtonClick={DeleteAdminButtonClick} isReadOnly={isReadOnly}></AdminRegistryTable>
          </div>
        </div>

      </div>
    </Layout>
  );

}

export default AdminRegistry;   